import { useState } from "react";

import './CustomDatePicker.scss';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { useCallback } from "react";
import { useEffect } from "react";

export const CustomDatePicker = ({date, setDate, ...props}) => {

    const [open, setOpen] = useState(false);

    const handleOpen = useCallback(()=>{
        setOpen(true);
    },[open]);

    const handleClose = useCallback(()=>{
        setOpen(false);
    },[open]);


    return <div className={`datePickerContainer ${open ? "open" : ""}`}>
        <DatePicker
            dateFormat={"dd/MM/yyyy"}
            className={"datePicker"}
            selected={date}
            onChange={(value) => setDate(value)}
            onCalendarOpen={() => handleOpen()}
            onCalendarClose={() => handleClose()}
            isClearable
            scrollableYearDropdown
        />
    </div>;
}